import * as React from 'react'
import { ShowMoreButton } from './ShowMoreButton'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ShowMoreButtonExamples = () => {
  return (
    <div className="ShowMoreButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ShowMoreButton />
      </Provider>
    </div>
  )
}
